import { HttpRequest } from '@angular/common/http';

export const isCallingApi = (environment, req: HttpRequest<any>) =>
  req.url.includes(environment.authInterceptorUrl) || req.url.includes('localhost');
